import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Login.css';

const Login = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();
  
  const [formData, setFormData] = useState({
    NombreUsu: '',
    clave: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Redirigir si ya está autenticado
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  // Limpiar el error después de 5 segundos
  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        setError('');
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [error]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'NombreUsu') {
      setFormData({
        ...formData,
        [name]: value.toUpperCase().slice(0, 3)
      });
    } 
    else if (name === 'clave') {
      setFormData({
        ...formData,
        [name]: value.replace(/\D/g, '').slice(0, 4)
      });
    }
    
    if (error) setError('');
  };

  const handleLogin = async () => {
    // Validaciones
    if (!formData.NombreUsu || formData.NombreUsu.length !== 3) {
      setError('El nombre de usuario debe tener 3 caracteres');
      return;
    }
    
    if (!formData.clave || formData.clave.length !== 4) {
      setError('La contraseña debe tener 4 dígitos');
      return;
    }
    
    setLoading(true);
    setError('');

    try {
      const response = await login(formData);
      if (response.success) {
        // La navegación se manejará por el useEffect
      }
    } catch (err) {
      setError(err.message || 'Credenciales inválidas');
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleLogin();
    }
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="login-brand">
          <div className="logo-placeholder">
            <img src="wikets-removebg-preview.png" alt="" />
          </div>
          <h3 className="app-title">Control de gastos</h3>
          <p className="app-subtitle">Ingrese con su usuario</p>
        </div>
      </div>
      
      <div className="login-right">
        <div className="login-card">
          <h2>Iniciar Sesión</h2>
          
          {error && (
            <div className="error-message" role="alert">
              <i className="error-icon">⚠️</i>
              <span>{error}</span>
            </div>
          )}
          
          <div className="login-form">
            <div className="form-group">
              <label htmlFor="NombreUsu">Nombre de usuario</label>
              <input
                type="text"
                id="NombreUsu"
                name="NombreUsu"
                value={formData.NombreUsu}
                onChange={handleChange}
                onKeyPress={handleKeyPress}
                placeholder="USUARIO"
                maxLength={3}
                autoComplete="username"
                disabled={loading}
                autoFocus
              />
              <small className="form-hint">3 letras</small>
            </div>

            <div className="form-group">
              <label htmlFor="clave">Contraseña</label>
              <input
                type="password"
                id="clave"
                name="clave"
                value={formData.clave}
                onChange={handleChange}
                onKeyPress={handleKeyPress}
                placeholder="••••"
                maxLength={4}
                inputMode="numeric"
                autoComplete="current-password"
                disabled={loading}
              />
              <small className="form-hint">PIN de 4 dígitos</small>
            </div>

            <button 
              type="button" 
              onClick={handleLogin}
              disabled={loading} 
              className="btn-login"
            >
              {loading ? (
                <>
                  <span className="spinner"></span>
                  Ingresando...
                </>
              ) : 'Ingresar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;